import { render, staticRenderFns } from "./EmployeeManagement.vue?vue&type=template&id=9600872c&scoped=true&"
import script from "./EmployeeManagement.vue?vue&type=script&lang=js&"
export * from "./EmployeeManagement.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeManagement.vue?vue&type=style&index=0&id=9600872c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9600872c",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/EmployeeTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fcbs%2Femployee%2FEmployeeManagement.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports